import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconStarredFilledStyle0 = cosmosIconCss;

const CosmosIconStarredFilled$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconStarredFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '8dbed655e0864eb0c3fc82d3e21edf4bc2afd29b', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '8970a7b9693b05f21f6e64633b8cf854b4654a4c', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '3d9624122118b0fda4b629df24b148064fcc46a2', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.5 3h-11a.5.5 0 0 0-.5.5v15.597a.4.4 0 0 0 .669.296L11 14.557l5.331 4.836a.4.4 0 0 0 .669-.296V3.5a.5.5 0 0 0-.5-.5Zm-2.144 5.014-1.712 1.513.626 2.162c.059.194.012.311-.128.311a.385.385 0 0 1-.187-.07l-1.953-1.28-1.953 1.28a.372.372 0 0 1-.187.07c-.136 0-.183-.113-.129-.311l.627-2.162-1.716-1.513c-.105-.09-.144-.152-.144-.23 0-.108.082-.159.284-.178l2.14-.195.864-2.185c.062-.16.124-.226.214-.226s.148.062.214.226l.864 2.185 2.136.195c.202.02.284.07.284.178 0 .078-.039.14-.144.23Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconStarredFilledStyle0; }
}, [1, "cosmos-icon-starred-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-starred-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-starred-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconStarredFilled$1);
            }
            break;
    } });
}

const CosmosIconStarredFilled = CosmosIconStarredFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconStarredFilled, defineCustomElement };
